import React from "react";
import { PopupEvent } from "./PopupEvent";
import { union } from "lodash";

export const PopupEventList = ({ events, userEvents, date, removeItem, canCreateItems, editItem }) => {
  const eventList = union(
    [...events, ...userEvents].filter(event => {
      if (event.start === date.format("YYYYMMDD")) return event;
      if (event.range !== false && event.range.contains(date)) return event;
    })
  );

  if (eventList.length > 0) {
    return (
      <ul className="calendar__popupEvents">
        {eventList.map((event, index) => (
          <PopupEvent key={index} event={event} removeItem={removeItem} editItem={editItem} canCreateItems={canCreateItems} />
        ))}
      </ul>
    );
  }

  return <div className="calendar__popupNoEvents">Geen items deze dag</div>;
};
